<div class="container">
    <div class="row">
        <div class="col-md-8 mx-auto">
            <div class="card">
                <div class="card-header">
                    <h3>Change Password</h3>
                </div>
                <div class="card-body">
                    <form class="form"  #ngchangePwdForm="ngForm" name="form"
                    (ngSubmit)="ngchangePwdForm.form.valid && onSubmit()" novalidate>
                         
                        <div class="form-group">
                            <label>Current Password</label>
                            <input [type]="currentType?'password':'text'" class="form-control" required  [(ngModel)]="oldpassword" id="oldassword" name="oldpassword">
                            <span class="eyeicon" (click)="viewcurrentpassword()"><i [ngClass]="currPassVisible?'fa fa-eye':'fa fa-eye-slash'"></i></span>

     
                        </div>



                        <div class="form-group">
                            <label>Password</label>
                            <input [type]="changetype?'password':'text'" class="form-control"  required  [(ngModel)]="password" id="password" name="password" >
                            <span class="eyeicon1" (click)="viewpassword()"><i [ngClass]="visiblePassword?'fa fa-eye':'fa fa-eye-slash'"></i></span>
                        </div>
                        <div class="form-group">
                            <label>Confirm Password</label>
                            <input [type]="changeConfirmType?'password':'text'" class="form-control"  required  [(ngModel)]="confirmPassword" id ="confirmPassword" name="confirmPassword">
                            <span class="eyeicon2" (click)="viewconfirmpassword()"><i [ngClass]="visibleConfirmPassword?'fa fa-eye':'fa fa-eye-slash'"></i></span>
                        </div>
                        <div class="form-group">
                            <button type="submit" class="btn btn-success">Submit</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</div>